import { Structure, StructureElement, } from 'molstar/lib/mol-model/structure/structure';
import { Script } from 'molstar/lib/mol-script/script';
import { StructureSelection } from 'molstar/lib/mol-model/structure/query';
import { EmptyLoci } from 'molstar/lib/mol-model/loci';
import { Arguments, ExpressionArguments, } from 'molstar/lib/mol-script/language/symbol';

export function createResidueLociGetter(
  chain: string,
  positions?: number[],
  options?: { groupByResidueKey?: boolean }
): (structure: Structure) => Promise<StructureElement.Loci | EmptyLoci> {
  options ??= {};
  options.groupByResidueKey ??= true;

  if (Array.isArray(positions) && positions.length === 0) {
    return async () => EmptyLoci;
  }

  return async data => {
    const sel = Script.getStructureSelection(Q => {
      const args: ExpressionArguments<Arguments['@type']> = {};
      args['chain-test'] = Q.core.rel.eq([
        Q.struct.atomProperty.macromolecular.auth_asym_id(),
        chain,
      ]);
      if (positions) {
        args['residue-test'] = positions
          .map(p =>
            Q.core.rel.eq([
              Q.struct.atomProperty.macromolecular.auth_seq_id(),
              p,
            ])
          )
          .reduce((acc, eq) => Q.core.logic.or([acc, eq]));
      }
      if (options?.groupByResidueKey) {
        args['group-by'] = Q.struct.atomProperty.macromolecular.residueKey();
      }
      return Q.struct.generator.atomGroups(args);
    }, data);
    return StructureSelection.toLociWithSourceUnits(sel);
  };
}